<template>

  <v-card class="back" style="height: 680px">
    <v-layout column fill-height>
      <v-toolbar dark color="primary" dense flat>
        <v-toolbar-title>
          <span class="body-2 text-uppercase">{{$t('configurations')}}</span>
        </v-toolbar-title>

        <v-layout justify-end align-center pl-3>
          <v-tooltip dark color="secondary" bottom>
            <v-btn icon flat slot="activator" 
              :data-testid="$options.name + '__btn__' + 'download'"
              @click="">
              <svg-icon
                :color="'white'"
                :name="'download'"
                width="20"
              />
              <input ref="file-input" class="button-file-upload__input" type="file" title=" " multiple accept 
                v-if="!fileClear" 
                :data-testid="$options.name + '__input__' + 'FileAdd'"
                @change="(e) => onFileAdd(e)">
            </v-btn>
            <span class="caption">{{ $t('import') }}</span>
          </v-tooltip>
        </v-layout>

      </v-toolbar>

      <scroll-area>
        <template slot="body">
            <v-layout fill-height  >
              <v-layout column fill-height>

                <v-tabs
                  light
                  slider-color="primary"
                  v-model="panel"
                  height="40px"
                  style="width: 100%"
                  :data-testid="$options.name + '__tabs'"
                >

                <v-tabs-slider color="primary" style="height: 0px; max-width: 0px"></v-tabs-slider>

                  <v-tab
                    class="font-weight-normal"
                    v-for="(place, index) in getPlaces"
                    :key="index"
                    :data-testid="$options.name + '__' + place + '_tab'"
                  >
                    <template slot="default">
                      <div class="tab_wrapper">
                        <div :data-testid="$options.name + '__' + place + '_tab_template'"
                          :class="getPlaces[panel] == place ? 'tab__border' : 'custom-tab'">
                          {{ $t(place) }} 
                        </div>
                      </div>
                    </template>
                  </v-tab>

                </v-tabs>

                <scroll-table
                  :data="getTable"
                  :options="getOptions"
                  :subscribed="false"
                  @select="(payload) => onRowClick(payload)"
                />
              </v-layout>

            </v-layout>

        </template>

        <template slot="footer">

          <v-layout fill-height>
            <v-layout fill-height align-center justify-end>
              <v-btn dark small color="grey"
                :data-testid="$options.name + '__btn__' + 'cancel'"
                @click="$emit('close')" >
                  {{$t('cancel')}}
              </v-btn>
            </v-layout>
          </v-layout>

        </template>

      </scroll-area>

    </v-layout>

  </v-card>

</template>

<script lang="ts">
import Vue from 'vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import scrollTable from '@/nms/components/partials/scrolltable.vue'
import svgIcon from '@/nms/components/media/svg/static/svg-icon.vue'

// Типы
interface CommitItem {
  $id?: string
  id?: string
  cls?: string
  date?: string
  user?: string
  [key: string]: any
}

interface TableColumn {
  title: string
  value: string
  type: string
  width: string
}

interface TableData {
  columns: TableColumn[]
  rows: CommitItem[]
}

interface OptionsColumns {
  [key: string]: { width: string }
}

interface OptionsData {
  columns: OptionsColumns
}

interface DeviceData {
  $id?: string
  [key: string]: any
}

interface CommitsResponse {
  data?: CommitItem[]
  [key: string]: any
}

export default Vue.extend({
  name: 'DOWNLOAD_CONFIGURATION_TABLE',

  components: {
    scrollArea,
    scrollTable,
    svgIcon
  },

  props: {
    data: {
      type: Object as () => DeviceData,
      default: () => ({})
    },
  },

  data(): {
    fileClear: boolean
    panel: number
    options: OptionsData
    commitsTable: TableData
  } {
    return {
      fileClear: false,
      panel: 0,
      options: {
        columns: {
          text: { width: '40%' },
          timestamp: { width: '40%' },
          actions: { width: '40%' },
          check: { width: '20%' },
          check_dependence: { width: '5%' },
        },
      },
      commitsTable: {
        columns: [
          {
            title: 'id',
            value: '$id',
            type: 'text',
            width: '60%'
          },
          {
            title: 'time download',
            value: 'date',
            type: 'timestamp',
            width: '10%'
          },
          {
            title: 'user',
            value: 'user',
            type: 'text',
            width: '15%'
          },
          {
            title: 'cls',
            value: 'cls',
            type: 'text',
            width: '15%'
          },
        ],
        rows: []
      },
    }
  },

  computed: {
    getData(): DeviceData {
      return this.data
    },

    getTable(): TableData {
      let rows: CommitItem[] = []

      if (this.getPlaces[this.panel] === 'running') {
        rows = this.commitsTable.rows.filter(row => row.cls === 'runningconfig')
      }
      if (this.getPlaces[this.panel] === 'starting') {
        rows = this.commitsTable.rows.filter(row => row.cls === 'startconfig')
      }

      return {
        columns: this.commitsTable.columns,
        rows: rows
      }
    },

    getOptions(): OptionsData {
      return this.options
    },

    getPlaces(): string[] {
      return ['starting', 'running']
    },
  },

  created(): void {
    this.setup()
  },

  methods: {
    setup(): void {
      this.loadCommits()
    },

    async loadCommits(): Promise<void> {
      if (!this.getData.$id) return

      try {
        this.setLoader('loadCommits', true)

        const running = await this.$bridge.customQuery('alarm', 'switch_settings/swset/getCommitsById', {
          id: this.getData.$id,
          type: 'runningconfig',
        }, 'get') as CommitsResponse

        const starting = await this.$bridge.customQuery('alarm', 'switch_settings/swset/getCommitsById', {
          id: this.getData.$id,
          type: 'startconfig',
        }, 'get') as CommitsResponse

        if (running?.data) {
          console.log(this.$options.name, 'running$', running)
          this.commitsTable.rows = this.$merge(this.commitsTable.rows, running.data)
        }
        if (starting?.data) {
          console.log(this.$options.name, 'starting$', starting)
          this.commitsTable.rows = this.$merge(this.commitsTable.rows, starting.data)
        }

        console.log(this.$options.name, 'loadCommits', 'this.commitsTable.rows', this.commitsTable.rows)
        this.setLoader('loadCommits', false)
      } catch (error) {
        console.log(this.$options.name, 'loadCommits', 'error', error)
        this.setLoader('loadCommits', false)
      }
    },

    onRowClick(val: CommitItem): void {
      console.log(this.$options.name, 'onRowClick', val)
      if (val?.$id && val.cls) {
        this.$emit('select', val)
        this.$emit('close')
      }
    },

    onFileAdd(e: Event): void {
      console.log(this.$options.name, 'onFileAdd', 'e', e)

      let filetype: string
      if (this.getPlaces[this.panel] === 'running') {
        filetype = 'runningconfig'
      } else if (this.getPlaces[this.panel] === 'starting') {
        filetype = 'startconfig'
      } else {
        filetype = ''
      }

      this.$emit('onFileAdd', {
        file: e,
        filetype: filetype
      })
    },

    setLoader(name: string, status: boolean): void {
      this.$store.dispatch('setLoader', {
        key: name,
        value: status
      })
    },
  },
})
</script>

<style lang="css" scoped>
.customToolbar {
  background-color: #58595B;
  height: 48px;
  font-size: 20px;
  font-weight: 500;
}
</style>

<style lang="stylus" scoped>

    .button-file-upload

        position: relative
        box-sizing: border-box

        &_extension

            &_blank

                padding-left: 0;
                border-color: transparent

            &_new

                padding-left: 0;
                border-color: transparent

        &__area

            display: flex
            justify-content: center

            width: 80px
            height: 80px

            border-radius: 50%
            border: 1px solid alpha(#000, .4)

        &__control

            position: relative
            overflow: hidden
            z-index: 2

            cursor: pointer

            &.fiv-icon-blank

                opacity: .4
                transition: opacity .4s

                &:hover

                    opacity: 1

            &.fiv-icon-new

                opacity: .4
                transition: opacity .4s

                &:hover

                    opacity: 1

        &__overlay

            position: absolute

            top: 0
            right: 0
            bottom: 0
            left: 0

            margin-right: -8px

            width: 100%
            /* height */

            background: alpha(#fff, .9)

            opacity: 0
            transition: opacity .4s

            &:hover

                opacity: 1

        &__delete

            cursor: pointer

            margin-right: -16px
            margin-top: -16px

            opacity: .5
            transition: opacity .4s

            &:hover

                opacity: 1

        &__input

            display: block
            position: absolute

            top: 0
            right: 0

            width: 100%
            height: 100%
            /* min-width: 100%
            min-height: 100% */

            text-align: right

            opacity: 0
            outline: none
            cursor: inherit

        &__name

            display: block /* Fallback for non-webkit */
            max-height: calc(20px * 2) /* Fallback for non-webkit */
            min-height: calc(20px * 2) /* Fallback for non-webkit */
            margin: 0 auto
            font-size: 12px
            line-height: 16px
            -webkit-line-clamp: 3
            -webkit-box-orient: vertical
            overflow: hidden
            text-overflow: ellipsis
            word-break: break-all
            text-align: center;


</style>
